import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { FaSave, FaTimes } from 'react-icons/fa';

const SegmentoModal = ({ show, onHide, segmento, onSave, loading }) => {
    const [formData, setFormData] = useState({
        clave: '',
        descripcion: ''
    });
    const [errors, setErrors] = useState({});

    // Resetear form cuando cambia el segmento o se abre/cierra el modal
    useEffect(() => {
        if (segmento) {
            // Modo edición
            setFormData({
                clave: segmento.clave || '',
                descripcion: segmento.descripcion || ''
            });
        } else {
            // Modo creación
            setFormData({
                clave: '',
                descripcion: ''
            });
        }
        setErrors({});
    }, [segmento, show]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        
        // Limpiar error del campo cuando el usuario empiece a escribir
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.clave.trim()) {
            newErrors.clave = 'La clave es requerida';
        } else if (formData.clave.length < 1) {
            newErrors.clave = 'La clave debe tener al menos 1 caracter';
        }
        
        if (!formData.descripcion.trim()) {
            newErrors.descripcion = 'La descripción es requerida';
        } else if (formData.descripcion.length < 2) {
            newErrors.descripcion = 'La descripción debe tener al menos 2 caracteres';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            onSave(formData, segmento?.clave);
        }
    };

    const isEditMode = !!segmento;

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    {isEditMode ? 'Editar Segmento' : 'Nuevo Segmento'}
                </Modal.Title>
            </Modal.Header>
            
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Clave *</Form.Label>
                        <Form.Control
                            type="text"
                            name="clave"
                            value={formData.clave}
                            onChange={handleChange}
                            isInvalid={!!errors.clave}
                            placeholder="Ingrese la clave del segmento"
                            maxLength={5}
                            disabled={isEditMode} // 🔒 Deshabilitado en modo edición
                            readOnly={isEditMode} // 📖 Solo lectura en modo edición
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.clave}
                        </Form.Control.Feedback>
                        <Form.Text className="text-muted">
                            {isEditMode 
                                ? 'La clave no puede modificarse' 
                                : `${formData.clave.length}/5 caracteres`
                            }
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Descripción *</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            name="descripcion"
                            value={formData.descripcion}
                            onChange={handleChange}
                            isInvalid={!!errors.descripcion}
                            placeholder="Ingrese la descripción del segmento"
                            maxLength={100}
                            style={{ resize: 'vertical' }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.descripcion}
                        </Form.Control.Feedback>
                        <Form.Text className="text-muted">
                            {formData.descripcion.length}/100 caracteres
                        </Form.Text>
                    </Form.Group>
                </Modal.Body>
                
                <Modal.Footer>
                    <Button 
                        variant="secondary" 
                        onClick={onHide}
                        disabled={loading}
                    >
                        <FaTimes className="me-2" />
                        Cancelar
                    </Button>
                    <Button 
                        variant="primary" 
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                {isEditMode ? 'Actualizando...' : 'Creando...'}
                            </>
                        ) : (
                            <>
                                <FaSave className="me-2" />
                                {isEditMode ? 'Actualizar Segmento' : 'Crear Segmento'}
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default SegmentoModal;